import {
  fetMatomoSiteId,
  fetchBindingOrderLineTrackingDocument,
  openIdDocument,
} from '../graphql/docs/motamo';
import { fetcher } from '../graphql/fetcher/index';

// 获取站点id
export const fetchMatomoSiteId = async () => {
  const res = await fetcher.query(fetMatomoSiteId, {});
  return res.data.value?.getMatomoSiteId;
};

// 获取openid
export const fetchOpenId = async (jsCode: string) => {
  const res = await fetcher.query(openIdDocument, {
    variables: {
      jsCode,
    },
  });
  return res.data.value?.getOpenIdByJsCode;
};

// 上报绑定订单项的来源（订单追踪）
export const fetchBindingOrderLineTracking = async (
  orderId: string,
  productVariantId: string,
  trackingPageType: string,
  trackingPageId: string
) => {
  const res = await fetcher.mutation(fetchBindingOrderLineTrackingDocument, {
    orderId,
    productVariantId,
    trackingPageType,
    trackingPageId,
  });
  return res.data.value?.bindingOrderLineTracking;
};
